import { useButtonInteraction } from "@/scripts/ui/ButtonInteraction";
import { useComponentDisplayData } from "@/scripts/ui/ComponentDisplayData";
import { useComponentData } from "@/scripts/ui/ComponentData";
import { useComponentStylingType5 } from "@/scripts/ui/ComponentStylingType5";
export function useButton4() {
  let data = {};
  data.component = "CofigurableButtonComponent";
  let attr = (data.attributes = {});
  attr.componentData = useComponentData();
  attr.componentData.content = "CofigurableButtonContent2Component";
  attr.componentData.styling = useComponentStylingType5();
  attr.componentData.interaction = useButtonInteraction();
  attr.componentData.display = useComponentDisplayData();

  return data;
}
